<!-- @format -->

<div *transloco="let t" class="container">
  @if (studentWorkflow) {
    <fudis-grid [rowGap]="'md'">
      <fudis-grid-item>
        <div class="d-flex flex-column flex-sm-row justify-content-end gap-4">
          @if (shouldShowCancelButton()) {
            <fudis-button
              (handleClick)="openCancelDialog()"
              [label]="t('PROFILE.APPLICATIONS.CANCEL_APPLICATION_MODAL.BUTTON.OPEN_CANCEL_APPLICATION_MODAL')"
              [variant]="'primary'"
              data-cy="srew-cancel-button" />
          }
        </div>
      </fudis-grid-item>
      @if (isWorkflowCancelled()) {
        <fudis-notification [variant]="'warning'">{{ t("PROFILE.APPLICATIONS.APPLICATION_CANCELLED") }} </fudis-notification>
      }
      @if (isWaitingForDecision()) {
        <fudis-notification [variant]="'warning'">{{ t("PROFILE.APPLICATIONS.ATTACHMENT_DELIVERY_REMINDER") }} </fudis-notification>
      }
      @if (isWaitingForDecision()) {
        @if (getApplication()?.educationId | education | async; as education) {
          @if (education.studyRightExtensionInstructions) {
            <fudis-notification data-cy="srew-instructions" [variant]="'info'">{{
              education.studyRightExtensionInstructions | localizedString
            }}</fudis-notification>
          }
        }
      }
      @if (!!studentWorkflow?.decision) {
        <ng-container>
          <fudis-expandable [level]="2" [title]="t('STUDENT_APPLICATIONS.APPLICATION_INFO')">
            <ng-template fudisExpandableContent>
              <ng-container *ngTemplateOutlet="applicationInfo" />
            </ng-template>
          </fudis-expandable>
        </ng-container>
        <ng-container>
          <fudis-expandable [level]="2" [closed]="false" [title]="t('STUDENT_APPLICATIONS.DECISION_INFO')">
            <ng-template fudisExpandableContent>
              <ng-container *ngTemplateOutlet="decisionInfo" />
            </ng-template>
          </fudis-expandable>
        </ng-container>
      } @else {
        <fudis-heading [level]="2">{{ t("STUDENT_APPLICATIONS.APPLICATION_INFO") }}</fudis-heading>
        <ng-container *ngTemplateOutlet="applicationInfo" />
      }
    </fudis-grid>
    <ng-template #applicationInfo>
      <app-study-right-extension-workflow-summary [studentWorkflow]="studentWorkflow" />
    </ng-template>
    <ng-template #decisionInfo>
      <app-study-right-extension-workflow-decision-summary
        [studyRightExtensionWorkflowDecision]="getDecision()"></app-study-right-extension-workflow-decision-summary>
    </ng-template>
  }
</div>
